import React from 'react'
import { Box } from 'rebass'
import UprightLink from '../components/UprightLink'

const Links = () => (
  <Box bg="black" css={{ textAlign: 'center' }}>
    <UprightLink
      target="_blank"
      rel="noopener"
      href="https://teganandsara.com"
      color="white"
    >
      teganandsara.com
    </UprightLink>
  </Box>
)

export default Links
